// react
import React, { useEffect, useState } from "react";

// third-party
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
// application
import AsyncAction from "./AsyncAction";
import Currency from "./Currency";
import { cartAddItem } from "../../store/cart";
import { Wishlist16Svg, FM16Svg, WishHeart, Bedge3, Bedge1, Bag6Svg, FailSvg } from "../../svg";
import { compareAddItem } from "../../store/compare";
import { quickviewOpen } from "../../store/quickview";
import { url } from "../../services/utils";
import { wishlistAddItem } from "../../store/wishlist";

import { urlLink } from "../../helper";
import { FormattedMessage } from "react-intl";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";

function ProductCard(props) {
    const { customer, product, layout, cartAddItem, wishlistAddItem, compareAddItem } = props;

    const wish = useSelector((state) => state.wishlist);
    const compare = useSelector((state) => state.compare);
    const [wishUpdate, setWish] = useState();
    const [products, getProducts] = useState();

    useEffect(() => {
        if (wish.length) {
            if (wish.filter((e) => e.id == product.id).length) Object.assign(product, { wishlist: true });
            else {
                Object.assign(product, { wishlist: false });
            }
        } else {
            Object.assign(product, { wishlist: false });
        }
        setWish("");
    }, [wish]);

    useEffect(() => {
        if (wish.length) {
            if (wish.filter((e) => e.id == product.id).length) Object.assign(product, { wishlist: true });
            else {
                Object.assign(product, { wishlist: false });
            }
        } else {
            Object.assign(product, { wishlist: false });
        }
        setWish("");
    }, [wish]);

    const selectedData = useSelector((state) => state.locale);
    const cartToken = useSelector((state) => state.cartToken);

    const containerClasses = classNames("product-card", {
        "product-card--layout--grid product-card--size--sm": layout === "grid-sm",
        "product-card--layout--grid product-card--size--nl": layout === "grid-nl",
        "product-card--layout--grid product-card--size--lg": layout === "grid-lg",
        "product-card--layout--list": layout === "list",
        "product-card--layout--horizontal": layout === "horizontal",
    });

    let badges = [];
    let image;
    let price;
    let features;
    let priceBege = Math.round(`${100 - (parseInt(product.special_price) * 100) / parseInt(product.price)}`);
    let priceSale = `-${priceBege} %`;

    //Sale;
    if (product.special_price) {
        badges.push(
            <div className="badges-push-conteiner-fms">
                <div className="badges-sale-fms pointed io ">
                    <span>{priceSale}</span>
                </div>
            </div>
        );
    } else if (product.special_price && product.new === 1) {
        badges.push(
            <div className="badges-push-conteiner-fms">
                <div className="badges-fms pointed io ">
                    <span>{priceSale}</span>
                </div>
                <div className="badges-fms">
                    <Bedge1 />
                </div>
            </div>
        );
    } else if (product.special_price && product.new === 1 && product.qty === 0) {
        badges.push(
            <div className="badges-push-conteiner-fms">
                <div className="badges-fms pointed io ">
                    <span>{priceSale}</span>
                </div>
                <div className="badges-fms">
                    <Bedge1 />
                </div>
                <div className="badges-fms">
                    <Bedge3 />
                </div>
            </div>
        );
    }
    //New
    if (product.new === 1) {
        badges.push(
            <div className="badges-push-conteiner-fms">
                <div className="badges-new-fms">
                    <div className="badges-new-fms">
                        <Bedge1 />
                    </div>
                </div>
            </div>
        );
    }

    //SoldOut
    if (product.qty === 0) {
        badges.push(
            <div className="sold-out">
                <div className="badges-sold-fms">
                    <Bedge3 />
                </div>
            </div>
        );
    }

    if (product.images && product.images.length > 0) {
        image = (
            <div className="product-card__image product-image">
                {/* <div className="in_stock_fms"><FormattedMessage id="addToCart1" defaultMessage="Առկա է" /></div> */}
                <div className="wish_fms">
                    <div className="wish_and_fms">
                        <AsyncAction
                            action={() => {
                                return wishlistAddItem(
                                    product,
                                    customer.token ? customer.token : false,
                                    product.wishlist
                                ).then((e) => {
                                    if (e == false)
                                        toast.success(
                                            <span className="d-flex faild-toast-fms">
                                                <FailSvg />
                                                <FormattedMessage
                                                    id="please.login.toast "
                                                    defaultMessage="`Please login or register in order to add to favorites.`"
                                                />
                                            </span>
                                        );
                                });
                            }}
                            render={({ run, loading }) => (
                                <button
                                    type="button"
                                    onClick={run}
                                    className={classNames(
                                        "btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__wishlist",
                                        {
                                            "btn-loading": loading,
                                        }
                                    )}
                                >
                                    {wishUpdate || !product.wishlist ? <Wishlist16Svg /> : <WishHeart />}
                                </button>
                            )}
                        />
                        {compare.length == 0 ? (
                            <AsyncAction
                                action={() => compareAddItem(product)}
                                render={({ run, loading }) => (
                                    <button
                                        type="button"
                                        onClick={run}
                                        disabled={
                                            window.screen["width"] < 991 ? compare.length == 2 : compare.length == 3
                                        }
                                        className={classNames(
                                            "btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__wishlist",
                                            {
                                                "btn-loading": loading,
                                            }
                                        )}
                                    >
                                        <FM16Svg />
                                    </button>
                                )}
                            />
                        ) : compare[0].cats[0] === product.cats[0] ? (
                            <AsyncAction
                                action={() => compareAddItem(product)}
                                render={({ run, loading }) => (
                                    <button
                                        type="button"
                                        onClick={run}
                                        disabled={
                                            window.screen["width"] < 991 ? compare.length == 2 : compare.length == 3
                                        }
                                        className={classNames(
                                            "btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__wishlist",
                                            {
                                                "btn-loading": loading,
                                            }
                                        )}
                                    >
                                        <FM16Svg />
                                    </button>
                                )}
                            />
                        ) : (
                            <button
                                type="button"
                                onClick={() => {
                                    toast.success(
                                        <span className="d-flex faild-toast-fms">
                                            <FailSvg />
                                            <FormattedMessage
                                                id="compare.categories.didnt"
                                                defaultMessage="You can't compare two other categories of products"
                                            />
                                        </span>
                                    );
                                }}
                                disabled={window.screen["width"] < 991 ? compare.length == 2 : compare.length == 3}
                                className={classNames(
                                    "btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__wishlist"
                                )}
                            >
                                <FM16Svg />
                            </button>
                        )}
                    </div>
                </div>

                <Link to={url.product(product)} className="product-image__body">
                    <img
                        className="product-image__img"
                        src={product.images[0].medium_image_url || `${urlLink}/cache/medium/` + product.images[0]}
                        alt=""
                    />
                </Link>
            </div>
        );
    }
    if (product.special_price) {
        price = (
            <div className="product-card__prices prices-df-column">
                <span className="product-card__old-price">
                    <Currency value={parseInt(product.price)} />
                </span>{" "}
                <span className="product-card__new-price">
                    <Currency value={parseInt(product.special_price)} />
                </span>
            </div>
        );
    } else {
        price = (
            <div className="product-card__prices">
                <Currency value={parseInt(product.price)} />
            </div>
        );
    }

    if (product.attributes && product.attributes.length) {
        features = (
            <ul className="product-card__features-list">
                {product.attributes
                    .filter((x) => x.featured)
                    .map((attribute, index) => (
                        <li key={index}>{`${attribute.name}: ${attribute.values.map((x) => x.name).join(", ")}`}</li>
                    ))}
            </ul>
        );
    }

    return (
        <React.Fragment>
            <div className={containerClasses}>
                <div className="badges-conteiner-fms">{badges}</div>
                {image}
                <div className="d-flex product-card__info">
                    <div className="product-card__name">
                        <Link to={url.product(product)}>{product.name}</Link>
                    </div>
                </div>
                <div className="product-card__actions_fms">
                    {/* <div className="product-card__availability">
                        <FormattedMessage id="availability" defaultMessage="Հասանելիություն" /> :
                    <span className="text-success"><FormattedMessage id="inStock" defaultMessage="Առկա է" /></span>
                    </div> */}
                    {price}
                    <AsyncAction
                        action={() =>
                            cartAddItem(product, [], 1, cartToken.cartToken, customer.token ? customer.token : null)
                        }
                        render={({ run, loading }) => (
                            <React.Fragment>
                                <div className="product-card__buttons" onClick={run}>
                                    <span className="add-cart-button-fms">
                                        <FormattedMessage id="add" defaultMessage="Add to cart" />
                                    </span>
                                    <div className="bt-card-fms">
                                        <button
                                            type="button"
                                            className={classNames("product-card__addtocart_fms buttonwith-hover", {
                                                "btn-loading": loading,
                                            })}
                                        >
                                            <Bag6Svg />
                                            {/* <FormattedMessage id="buy" defaultMessage="Գնել" /> */}
                                        </button>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

ProductCard.propTypes = {
    /**
     * product object
     */
    product: PropTypes.object.isRequired,
    /**
     * product card layout
     * one of ['grid-sm', 'grid-nl', 'grid-lg', 'list', 'horizontal']
     */
    layout: PropTypes.oneOf(["grid-sm", "grid-nl", "grid-lg", "list", "horizontal"]),
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    cartAddItem,
    wishlistAddItem,
    compareAddItem,
    quickviewOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCard);
